import { useSelector } from 'react-redux';

import {
  getIsRoleIsPolygonCreator,
  getIsDocumentReviewerRole,
  getRole,
} from '@domains/user/store/slices/user-slice/user-slice';
import { UserRoles } from '@domains/user/utils/roles';
import { RolesPolynatorEnum } from '@domains/user/store/api-slices/roles-polynator.endpoint';
import { getCurrentEnvironment } from '../../../config/external-tools';
import {
  InternalModule,
  MODULE_GEORREF,
  MODULE_POLYNATOR,
  MODULE_POLYGON_VIEWER,
  MODULE_DOC_REVIEW,
  MODULE_LA_CENTRAL,
  MODULE_AT_CONSOLE,
} from '../launch.constants';

export const useVisibleModules = (): InternalModule[] => {
  const roles            = useSelector(getRole) ?? [];
  const isPolygonCreator = useSelector(getIsRoleIsPolygonCreator);
  const isDocReviewer    = useSelector(getIsDocumentReviewerRole);
  const isLeader         = roles.includes(UserRoles.IDM_LEAD);
  const hasPolygonRole   =
    roles.includes(RolesPolynatorEnum.PolygonCreator) ||
    roles.includes(RolesPolynatorEnum.PolygonViewer);

  const isLocal = getCurrentEnvironment() === 'local';

  return [
    MODULE_GEORREF,
    ...(isPolygonCreator ? [MODULE_POLYNATOR] : []),
    ...(!isPolygonCreator && hasPolygonRole ? [MODULE_POLYGON_VIEWER] : []),
    ...(isDocReviewer || isLeader ? [MODULE_DOC_REVIEW] : []),
    ...(isLeader ? [MODULE_LA_CENTRAL] : []),
    // AT Console: solo visible en local hasta que el módulo esté listo para QA/prod.
    ...(isLocal ? [MODULE_AT_CONSOLE] : []),
  ];
};
